import classNames from "classnames";

import { CardHeader } from "@/components/CardHeader";

import styles from "./FilterHeader.module.scss";

interface FilterHeaderProps {
  leftSlot?: JSX.Element;
  centerSlot?: JSX.Element;
  rightSlot?: JSX.Element;
  centered?: boolean;
  className?: string;
}

const FilterHeader = ({
  leftSlot,
  centerSlot,
  rightSlot,
  centered,
  className = "",
}: FilterHeaderProps) => {
  return (
    <CardHeader
      className={classNames(styles.root, className)}
      centerSlotClassName={centered ? styles.centered : styles.centerSlot}
      leftSlot={leftSlot}
      centerSlot={centerSlot}
      rightSlot={rightSlot}
    />
  );
};

export default FilterHeader;
